import React from 'react';

type PortalAcronymProps = {
  className?: string;
  style?: React.CSSProperties;
};

/**
 * Expansion of the ITA P.O.R.T.A.L. name. Shared so the wording stays identical
 * wherever the branding line appears (login page, change log).
 */
export default function PortalAcronym({ className, style }: PortalAcronymProps) {
  return (
    <p className={className} style={style}>
      where <strong>P</strong>lanning, <strong>O</strong>perations, <strong>R</strong>esources,{' '}
      <strong>T</strong>racking, <strong>A</strong>ssets &amp; <strong>L</strong>ogistics meet.
    </p>
  );
}
